import React, { useEffect, useState } from "react";
import Header from "./Header";
import { useLocation } from "react-router-dom";


const Layout = ({ children }) => {
  const location = useLocation()
  return (
    <React.Fragment>
      <div className="vh-100 overflow-hidden d-flex flex-column">
        <Header />
        <div className="dashboard-container overflow-y-scroll">
          <div className="bg-theme-light w-100 h-100">{children}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Layout;
